import api from "../api/student";
import {createError, logError, logSuccess} from "../../../ui/Notify";
import types from "./types";

function requestStudents() {
  return {
    type: types.GET_STUDENT_LIST_REQUEST,
    isFetchingStudentList: true
  };
}

function requestStudentsCompleted(studentList) {
  return {
    type: types.GET_STUDENT_LIST_COMPLETED,
    isFetchingStudentList: false,
    studentList
  };
}

function requestStudentsError(studentListError) {
  return {
    type: types.GET_STUDENT_LIST_ERROR,
    isFetchingStudentList: false,
    studentListError
  };
}

export function getStudentList() {
  return dispatch => {
    dispatch(requestStudents());
    return api.getStudentList()
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestStudentsCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestStudentsError(message));
        } else {
          logError(err);
          dispatch(requestStudentsError(createError("Не удалось загрузить список обучающихся")));
        }
      });
  };
}

function requestStudentPrograms() {
  return {
    type: types.GET_STUDENT_PROGRAM_LIST_REQUEST,
    isFetchingStudentProgramList: true
  };
}

function requestStudentProgramsCompleted(studentProgramList) {
  return {
    type: types.GET_STUDENT_PROGRAM_LIST_COMPLETED,
    isFetchingStudentProgramList: false,
    studentProgramList
  };
}

function requestStudentProgramsError(studentProgramListError) {
  return {
    type: types.GET_STUDENT_PROGRAM_LIST_ERROR,
    isFetchingStudentProgramList: false,
    studentProgramListError
  };
}

export function getStudentProgramList(id) {
  return dispatch => {
    dispatch(requestStudentPrograms());
    return api.getStudentProgramList(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestStudentProgramsCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestStudentProgramsError(message));
        } else {
          logError(err);
          dispatch(requestStudentProgramsError(createError("Не удалось загрузить список программ обучающегося")));
        }
      });
  };
}

export default {
  getStudentList,
  getStudentProgramList
}
